/**
 * This is the main entry point of the Javascript.
 * It initializes the necessary components.
 */

import Links from "./components/Links";

document.addEventListener("DOMContentLoaded", () => {

    const burgerWrapper = document.querySelector(".burger-menu");
    const burgerClose = document.querySelector(".burger-menu__close");
    const burgerLines = document.querySelector(".burger-js");
    const header = document.querySelector(".header");

    if (burgerLines) {
        burgerLines.addEventListener("click", function () {
            if (burgerWrapper) {
                burgerWrapper.classList.add("active");
            }
        });
    }

    if (burgerClose) {
        burgerClose.addEventListener("click", function () {
            if (burgerWrapper) {
                burgerWrapper.classList.remove("active");
            }
        });
    }

    if (burgerWrapper) {
        burgerWrapper.addEventListener("click", function (e) {
            if (e.target === burgerWrapper) {
                burgerWrapper.classList.remove("active");
            }
        });
    }

    if (header) {
        const toggleFixed = () => {
            header.classList.toggle("fixed", window.scrollY > 0);
        };

        toggleFixed();
        window.addEventListener("scroll", toggleFixed);
    }

    Links();
});